'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var Twine = _interopDefault(require('twine'));

function Typing(word, options) {
  var defaults = {
    initialValue: '',
    typeSpeed: 30,
    autoplay: false
  };

  this.config = _Object$assign(defaults, options);

  this.letters = this.wordToArray(word);

  this.value = this.config.initialValue;

  if (this.config.autoplay) {
    this.type();
  }
}

Typing.prototype.type = function () {
  var _this = this;

  var letters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.letters;

  var humanize = this.humanizedSpeed(this.config.typeSpeed);

  setTimeout(function () {
    _this.addCharacter(letters.shift(1));

    Twine.refresh();

    if (letters.length) {
      _this.type(letters);
    }
  }, humanize);
};

Typing.prototype.getValue = function (node) {
  $(node).trigger('input');

  return this.value;
};

Typing.prototype.humanizedSpeed = function (typeSpeed) {
  return Math.round(Math.random() * 40) + typeSpeed;
};

Typing.prototype.addCharacter = function (character) {
  this.value += character;
  return this.value;
};

Typing.prototype.wordToArray = function (text) {
  if (!text) {
    return [];
  }

  return text.split('');
};

Twine.register('Typing', Typing);

module.exports = Typing;
